<div class="container-fluid">
  <div class="row">
    <div class="col-md-8 offset-md-2 pt-1 pb-3" *ngIf="detailForum?.id">
      <div style="display: flex;align-items: baseline; gap: 0.25rem;">
        <div class="back-button-section">
          <button class="back-button" (click)="goBack()"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
        </div>
        <app-breadcrumb
          *ngIf="detailForum && detailForum.title"
          [data]="[
        {
          name: 'Forum',
          link: '/forum',
        },
        {
          name: detailForum.title,
          link: '/forum/' + detailForum?.uuid,
          active: true
        }
      ]"
        >
        </app-breadcrumb>
      </div>
      <div id="forum_detail_post" class="forum-detail-post">
        <div class="forum-detail-post__body">
          <div class="user-details container-char-image" ngbDropdown>
            <app-forum-profile-popup ngbDropdownMenu [user]="detailForum.user"></app-forum-profile-popup>
            <img loading="lazy" ngbDropdownToggle src="{{ !detailForum.user?.image ? '../../../../assets/images/new/badge.png' : imgUrl + detailForum.user?.image }}" />
            <div class="user-details__content">
              <div class="name">
                {{ detailForum.user?.userName || "Unknown" }}
              </div>
              <small> {{ detailForum.createdAtText }} ago </small>
            </div>
            <div class="copy-link">
              <i class="fa-solid fa-link" (click)="copyLink('forum', detailForum)"></i>
            </div>
            <div class="heart">
              {{ detailForum?.forumLikes?.length }}
              <i (click)="likeForum(detailForum?.id, detailForum)" class="fa-{{ hasCheckedForum(detailForum?.forumLikes) ? 'solid' : 'regular' }} fa-heart"></i>
            </div>
            @if(isLogin == 1) {
            <div class="list">
              <div ngbDropdown>
                <div aria-hidden="true" id="list-1" ngbDropdownToggle>
                  <i class="fa-solid fa-ellipsis-v"></i>
                </div>
                <ul ngbDropdownMenu aria-labelledby="list-1">
                  <li ngbDropdownItem *ngIf="appUserId == detailForum.createdBy || roleSer.roles?.permissions['MEMBER_KOPI_TALK']?.includes('EDIT')" (click)="forumFormModal()"><i class="fa-solid fa-pen"></i> Edit</li>
                  <li ngbDropdownItem *ngIf="appUserId == detailForum.createdBy || roleSer.roles?.permissions['MEMBER_KOPI_TALK']?.includes('DELETE')" (click)="deletePost($event)"><i class="fa-solid fa-trash"></i> Delete</li>
                  <li ngbDropdownItem (click)="$event.preventDefault(); handleReport(detailForum.id)"><i class="fa-solid fa-flag"></i> Report</li>
                </ul>
              </div>
            </div>
            }
          </div>
          <div class="d-flex gap-2 flex-column px-3 py-3" style="background-color: #eee">
            <div class="title">{{ detailForum.title }}</div>

            <div class="grid-image" *ngIf="detailForum?.images?.length > 0">
              <div style="position: relative; overflow: hidden">
                <img loading="lazy" class="main-image" [src]="imgUrl + (detailForum?.activeImage ?? detailForum?.images[0])" (error)="commonService.handleError($event)" />
              </div>

              <div class="slide-images">
                <ng-container *ngFor="let image of detailForum?.images">
                  <div *ngIf="image != ''" (click)="detailForum.activeImage = image" (error)="commonService.handleError($event)" [ngStyle]="{ 'background-image': 'url(' + imgUrl + image + ')' }"></div>
                </ng-container>
              </div>
            </div>
          </div>
          <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let image of detailForum?.user?.images; let i = index">
              <ng-template class="slide text-center" carouselSlide [id]="i">
                <img loading="lazy" src="{{ imgUrl }}{{ image }}" class="rounded-lg mx-auto" alt="" />
              </ng-template>
            </ng-container>
          </owl-carousel-o>

          <div class="content">
            <div [innerHTML]="detailForum.message"></div>

            <div class="comments">
              <div class="comments__title">
                Comments
                <div class="add" *ngIf="isLogin == 1 && !detailForum.isMuted" (click)="showMessageBoxReply = !showMessageBoxReply">Comment <i class="fa-solid fa-arrow-alt-circle-down"></i></div>
              </div>
              <div class="box-reply" *ngIf="isLogin == 1 && showMessageBoxReply">
                <form (ngSubmit)="storeForumMessageReply()">
                  <app-editor [(innerValue)]="detailForum.replyText"></app-editor>
                  <button class="button-2" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send</button>
                </form>
              </div>
              <div class="comments__card" *ngFor="let reply of detailForum?.replies; let i = index">
                <div class="comments__card--left container-char-image" ngbDropdown>
                  <app-forum-profile-popup ngbDropdownMenu [user]="reply.user"></app-forum-profile-popup>
                  <img loading="lazy" ngbDropdownToggle src="{{ !reply.user?.image ? '../../../../assets/images/new/badge.png' : imgUrl + reply.user?.image }}" />
                </div>
                <div class="comments__card--center">
                  <div class="comments__card--center__message">
                    <div class="header">
                      <div class="name">
                        {{ reply.user?.userName }} {{ reply.reply }}
                        <span *ngIf="reply.user.level > 0">Level {{ reply.user.level }}</span>
                      </div>
                      <div class="options">
                        <!-- <div class="options__list" *ngIf="isLogin == 1">
                            <div
                              class="options__list--bar"
                              (click)="handleShowOptionForumReply(i)"
                            >
                              <i class="fa-solid fa-ellipsis-v"></i>
                            </div>
                            <div
                              class="options__list--menu"
                              (mouseleave)="handleShowOptionForumReply(i)"
                              [class.d-none]="!reply.showOption"
                            >
                              <div
                                class="item"
                                
                                (click)="editForumMessage($event, reply)"
                              >
                                <i class="fa-solid fa-pen"></i> Edit
                              </div>
                              <div
                                class="item"
                                
                                (click)="deleteForumMessageReply($event, reply.id)"
                              >
                                <i class="fa-solid fa-trash"></i> Delete
                              </div>
                              <div
                                class="item"
                                (click)="showReplyMessageBox($event, reply)"
                              >
                                <i class="fa-solid fa-comment-dots"></i> Reply
                              </div>
                              <div
                                class="item"
                                (click)="showReplyMessageBox($event, reply)"
                              >
                                <i class="fa-solid fa-flag"></i> Report
                              </div>
                            </div>
                          </div> -->
                        <!-- <div
                            class="options__comments"
                            *ngIf="reply?.replies.length != 0"
                            (click)="reply.showReply = !reply.showReply"
                          >
                            <i class="fa-solid fa-arrow-alt-circle-down"></i>
                          </div> -->
                      </div>
                    </div>
                    <div *ngIf="!reply.isEdit" class="text {{ isOwnMessage(reply) ? 'own' : '' }}">
                      <div [innerHtml]="reply.message"></div>
                      <div class="comments__card--center__list" *ngIf="isLogin == 1 && !detailForum.isMuted">
                        <div class="comments__card--center__list--bar" (click)="handleShowOptionForumReply(i)">
                          <i class="fa-solid fa-ellipsis-v"></i>
                        </div>
                        <div class="comments__card--center__list--menu" (mouseleave)="handleShowOptionForumReply(i)" [class.d-none]="!reply.showOption">
                          <div class="item" (click)="editForumMessage($event, reply)">
                            <i class="fa-solid fa-pen"></i>
                            Edit
                          </div>
                          <div class="item" (click)="deleteForumMessageReply($event, reply.id)"><i class="fa-solid fa-trash"></i> Delete</div>
                          <div class="item" (click)="showReplyMessageBox($event, reply)"><i class="fa-solid fa-comment-dots"></i> Reply</div>
                          <div class="item" (click)="handleReport(reply.id, 'forum_reply')"><i class="fa-solid fa-flag"></i> Report</div>
                        </div>
                      </div>
                    </div>
                    <div class="comments__card--center__details">
                      <div *ngIf="!reply.isEdit">
                        {{ formatDate(reply.createdAt) }}
                      </div>
                      <div *ngIf="reply?.replies?.length != 0">{{ reply?.replies.length }} comments</div>
                    </div>
                  </div>
                  <!-- *ngIf="reply.showReply" -->
                  <div class="comments__card--center__reply" *ngIf="reply?.replies?.length">
                    <div class="comments__card--center__reply--card" *ngFor="let child of reply.replies; let iReply = index">
                      <!-- <div class="comments__card--center__reply--card__left">
                          <div class="name">{{ child.user.userName }}</div>
                          <div class="type">{{ child.user.userType }}</div>
                        </div> -->
                      <div class="comments__card--center__reply--card__center">
                        <div class="name">
                          {{ child.user.userName }}
                          <span *ngIf="child.user.level > 0">Level {{ child.user.level }}</span>
                        </div>
                        <div *ngIf="!child.isEdit" class="comments__card--center__reply--card__center--message">
                          <div class="text {{ isOwnMessage(child) ? 'own' : '' }}">
                            <div [innerHtml]="child.message"></div>
                            <div class="comments__card--center__reply--card__center--list" *ngIf="!detailForum.isMuted">
                              <div class="comments__card--center__reply--card__center--list__bar" (click)="handleShowOptionForumReplyChild(child)">
                                <i class="fa-solid fa-ellipsis-v"></i>
                              </div>
                              <div class="comments__card--center__reply--card__center--list__menu" (mouseleave)="handleShowOptionForumReplyChild(child)" [class.d-none]="!child.showOption">
                                <div class="item" (click)="editForumMessageReply($event, child)"><i class="fa-solid fa-pen"></i> Edit</div>
                                <div class="item" (click)="deleteForumMessageReply($event, child.id, i)"><i class="fa-solid fa-trash"></i> Delete</div>
                                <div class="item" (click)="handleReport(child.id, 'forum_reply')"><i class="fa-solid fa-flag"></i> Report</div>
                              </div>
                            </div>
                          </div>
                          <div class="time">
                            {{ formatDate(child.createdAt) }}
                          </div>
                        </div>
                        <ng-container *ngIf="child.isEdit">
                          <form (ngSubmit)="storeForumMessageEdit(child)" class="w-100">
                            <app-editor [(innerValue)]="child.messageEdit"></app-editor>
                            <div class="mt-3 float-right">
                              <button type="button" (click)="child.isEdit = false" class="btn btn-danger mr-2" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-times"></i> Cancel</button>
                              <button class="btn btn-primary" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send</button>
                            </div>
                          </form>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <ng-container *ngIf="reply.isEdit">
                    <form (ngSubmit)="storeForumMessageEdit(reply)" class="w-100">
                      <app-editor [(innerValue)]="reply.messageEdit"></app-editor>
                      <div class="mt-3 float-right">
                        <button type="button" (click)="reply.isEdit = false" class="btn btn-danger mr-2" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-times"></i> Cancel</button>
                        <button class="btn btn-primary" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send</button>
                      </div>
                    </form>
                  </ng-container>

                  <ng-container *ngIf="reply.showReplyBox">
                    <form (ngSubmit)="storeForumMessageReply(null, reply)" class="w-100 mt-2">
                      <app-editor [(innerValue)]="reply.replyText"></app-editor>
                      <div class="mt-3 float-right">
                        <button type="button" (click)="reply.showReplyBox = false; reply.showOption = false" class="btn btn-danger mr-2" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-times"></i> Cancel</button>
                        <button class="btn btn-primary" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send Reply</button>
                      </div>
                    </form>
                  </ng-container>

                  <!-- <ng-container *ngIf="reply.isEdit">
                    <form (ngSubmit)="storeForumMessageEdit(reply.id)" class="w-100">
                        <ckeditor [editor]="Editor" [data]="EditorData" [config]="EditorConfig"
                            [(ngModel)]="reply.messageEdit" name="ckEditorText" ngDefaultControl
                            (change)="onEditorChange($event)">
                        </ckeditor>
                        <div class="mt-3 float-right">
                            <button type="button" (click)="reply.isEdit = false" class="btn btn-danger mr-2"
                                [class.disabled]="reply.hasSubmit" [disabled]="reply.hasSubmit">
                                <i class="fa-solid fa-times"></i> Cancel
                            </button>
                            <button class="btn btn-primary" [class.disabled]="reply.hasSubmit"
                                [disabled]="reply.hasSubmit">
                                <i class="fa-solid fa-paper-plane"></i> Send
                            </button>
                        </div>
                    </form>
                </ng-container> -->
                </div>
                <!-- <div class="comments__card--right">
      
                    <div
                      class="comments__card--right__comments"
                      *ngIf="reply?.replies.length != 0"
                      (click)="reply.showReply = !reply.showReply"
                    >
                      <i class="fa-solid fa-arrow-alt-circle-down"></i>
                    </div>
                  </div> -->
              </div>

              <div *ngIf="detailForum?.replies?.length < 1">
                <div class="alert alert-secondary text-center" role="alert"><i class="fa-regular fa-comment-alt"></i> There are no replies posted at this time</div>
              </div>
              <!-- @if(appUserLevel != 0){
              <div class="my-3">
                <div class="alert alert-danger" role="alert">
                  <div class="d-flex flex-column flex-md-row justify-content-between">
                    <span class="my-auto">
                      <i class="fa-solid fa-exclamation-circle"></i> Please log in first if you want to discuss in the <b>{{
                        shopForum?.userName }}</b> Forum
                    </span>
                    <button class="btn btn-sm btn-primary" (click)="loginHere()">Login Here !</button>
                  </div>
                </div>
              </div>
              } -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2" *ngIf="detailForum?.id">
      <app-news-forum [forumId]="detailForum?.id"></app-news-forum>
    </div>
  </div>
</div>
<app-form-forum #forumForm></app-form-forum>
<app-sign-in #SignIn></app-sign-in>
